import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import DriveOffShellLayout from './DriveOffShellLayout.jsx';

const STANDALONE_PATHS = ['/callback'];

const ShellRouteBoundary = () => {
  const location = useLocation();
  const isStandalone = STANDALONE_PATHS.some((path) => location.pathname.startsWith(path));

  if (isStandalone) {
    return <Outlet />;
  }

  return <DriveOffShellLayout />;
};

export default ShellRouteBoundary;
